const getCtaAfterSubmissionFormDataLocalStorageKey = require("./getCtaAfterSubmissionFormDataLocalStorageKey");

/**
 * @return {Object}
 */
module.exports = function () {
    const defaultFormData = {
        FirstName: 'Anonymous',
        LastName: 'Anonymous',
        Email: 'anonymous@iterable.com',
        Country: 'United States',
        formid: "1122",
        munchkinId: "723-YAV-537"
    };

    let formData = defaultFormData;

    const returningUser = localStorage.getItem("returningUserStore");
    if (returningUser) {
        formData = JSON.parse(returningUser);
    } else {
        const localStorageKey = getCtaAfterSubmissionFormDataLocalStorageKey();

        const formDataRaw = window.localStorage.getItem(localStorageKey);

        if (formDataRaw) {
            try {
                formData = JSON.parse(formDataRaw);
            } catch (e) {
                console.error("Could not retrieve one-click-registration data");
            }
        }
    }

    for (let key of ["FirstName", "LastName", "Email", "Company", "Country", "formid", "munchkinId"]) {
        if (!(key in formData) || !formData[key]) {
            formData[key] = defaultFormData[key];
        }
    }

    return formData;
}